var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconCandles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2273",
    "data-name": "Group 2273",
    transform: "translate(-237.625 -694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2288",
    "data-name": "Path 2288",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(237.625 694)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_menorah_",
    "data-name": "FontAwsome (menorah)",
    d: "M19.911,5.1H18.637A.637.637,0,0,0,18,5.734v7.734h2.549V5.734A.637.637,0,0,0,19.911,5.1Zm-.637-1.274a1.274,1.274,0,0,0,1.274-1.274A8.427,8.427,0,0,0,19.274,0,8.427,8.427,0,0,0,18,2.549,1.274,1.274,0,0,0,19.274,3.823Z",
    transform: "translate(234.352 702.266)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_menorah_2",
    "data-name": "FontAwsome (menorah)",
    d: "M19.911,5.1H18.637A.637.637,0,0,0,18,5.734v7.734h2.549V5.734A.637.637,0,0,0,19.911,5.1Zm-.637-1.274a1.274,1.274,0,0,0,1.274-1.274A8.427,8.427,0,0,0,19.274,0,8.427,8.427,0,0,0,18,2.549,1.274,1.274,0,0,0,19.274,3.823Z",
    transform: "translate(229.486 702.266)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "FontAwsome_menorah_3",
    "data-name": "FontAwsome (menorah)",
    d: "M19.911,5.1H18.637A.637.637,0,0,0,18,5.734v7.734h2.549V5.734A.637.637,0,0,0,19.911,5.1Zm-.637-1.274a1.274,1.274,0,0,0,1.274-1.274A8.427,8.427,0,0,0,19.274,0,8.427,8.427,0,0,0,18,2.549,1.274,1.274,0,0,0,19.274,3.823Z",
    transform: "translate(239.215 702.266)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconCandles);
export default __webpack_public_path__ + "static/media/32-icon-candles.c0b79b59.svg";
export { ForwardRef as ReactComponent };